exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n}\n\n#root {\n  height: 100vh;\n  width: 100vw;\n}\n", ""]);

